export default __webpack_public_path__ + "static/media/XWidget.3d086f35.svg";